import { Navigate } from "react-router-dom";
import type { ReactElement } from "react";
import { isLoggedIn } from "@/lib/auth";


export const ProtectedRoute = ({ children }: { children: ReactElement }) => {
	if (!isLoggedIn()) return <Navigate to="/login" replace />;
	return children;
};